<template>
  <div class="app-activation-info-modal">
    <b-modal :id="'activationInfoModal'"
             size="xl"
             data-qa="modal"
             v-model="showModal"
             @hide="hideModal()"
             :hide-footer="modalHideFooter"
             :title="modalTitle"
             :static="modalStatic"
             header-bg-variant="custom"
             header-text-variant="custom"
             body-bg-variant="custom"
             body-text-variant="custom"
             footer-bg-variant="custom"
             footer-text-variant="custom"
    >
      <slot name="txtActivationInfoModalCollectData"> <p>Content Text</p> </slot>
      <template v-slot:modal-footer>
        <b-button variant="primary" v-on:click="keepData">
          <slot name="txtActivationInfoModalKeepData">Daten behalten</slot>
        </b-button>
        <b-button variant="primary" v-on:click="collectData">
          <slot name="txtActivationInfoModalRefreshData">Daten löschen und erfassen</slot>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { BModal } from 'bootstrap-vue'
import { mapMutations } from 'vuex'
import processSteps from '@/mixins/processSteps'
import { stepName as info } from '@/components/process/LIDL/Activation/Info/ActivationInfo.vue'
import { stepName as personal } from '@/components/process/LIDL/Activation/PersonalData/EnterPersonalData.vue'

export default {
  components: { BModal },
  mixins: [
    processSteps(info, info, personal)
  ],
  props: {
    modalTitle: {
      type: String,
      default: ''
    },
    modalHideFooter: {
      type: Boolean,
      default: false
    },
    modalStatic: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentCustomer: {
        activationInfo: false
      }
    }
  },
  computed: {
    showModal: {
      get () {
        return this.$store.getters.viewModal('activationInfo')
      },
      set () {
        // no manual set
      }
    }
  },
  methods: {
    ...mapMutations('activation/info', [
      'collectActivationData',
      'keepActivationData'
    ]),
    hideModal () {
      this.$store.commit('changeModalViewState', { modal: 'activationInfo', viewState: false })
    },
    collectData () {
      this.collectActivationData(this.nextStep)
    },
    keepData () {
      this.keepActivationData()
    }
  }
}

</script>
